'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var styles = require('@material-ui/styles');
var Tab = require('@material-ui/core/Tab');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Tab__default = /*#__PURE__*/_interopDefaultLegacy(Tab);

var useStyles = styles.makeStyles(theme => ({
  root: {
    '&:hover': {
      opacity: 1
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    minHeight: 56,
    minWidth: 'unset',
    color: theme.palette.text.secondary,
    textTransform: 'initial',
    flexDirection: 'column',
    alignItems: 'center',
    padding: "0 16px",
    '&.Mui-selected': {
      color: theme.palette.primary.main
    }
  }
}));
var NavTab = props => {
  var classes = useStyles();
  return /*#__PURE__*/React__namespace.createElement(Tab__default['default'], _rollupPluginBabelHelpers['extends']({
    classes: {
      root: classes.root,
      wrapper: classes.wrapper,
      labelIcon: classes.labelIcon
    }
  }, props));
};

exports.NavTab = NavTab;
exports.default = NavTab;
